import { apiService } from './apiService';
import { API_CONFIG } from '../config/apiConfig';
import type { Customer } from '@/types';

// Payload esperado pelo endpoint: POST /api/GenericIntegrations/SalvarCliente
// Ele recebe uma LISTA de ClienteAppViewModel.
export type CreateCustomerInput = {
  name: string;
  document?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  vendedorId?: number;
};

type ApiResposta = {
  Sucesso?: boolean;
  Mensagem?: string;
  ID?: number; // PessoaClienteID
  PessoaID?: number;
  IDlocal?: any;
};

type ApiClienteAppViewModel = {
  // Campos usados pelo backend.
  ID?: any;
  Nome?: string;
  CPFCNPJ?: string;
  Telefone?: string;
  Email?: string;
  Logradouro?: string;
  Bairro?: string;
  Cidade?: string;
  UF?: string;
  Cep?: string;
  Limite?: number;
  TipoContribuinte?: number;
  ConsumidorFinal?: boolean;
  VendedorID?: number;
  PessoaID?: number; // se for update
};

export async function createCustomerOnErp(input: CreateCustomerInput): Promise<Customer> {
  API_CONFIG.initialize();

  if (!API_CONFIG.baseURL) {
    throw new Error('API n�o configurada (baseURL vazio)');
  }

  const payload: ApiClienteAppViewModel[] = [
    {
      ID: 0,
      Nome: input.name,
      CPFCNPJ: input.document || '',
      Telefone: input.phone || '',
      Email: input.email || '',
      Logradouro: input.address || '',
      Bairro: '',
      Cidade: input.city || '',
      UF: input.state || '',
      Cep: input.zipCode || '',
      Limite: 0,
      TipoContribuinte: 0,
      ConsumidorFinal: true,
      VendedorID: input.vendedorId || 0,
      PessoaID: 0,
    },
  ];

  const resp = await apiService.post<ApiResposta[]>('/api/GenericIntegrations/SalvarCliente', payload);

  const first = Array.isArray(resp) ? resp[0] : undefined;
  if (!first?.Sucesso) {
    throw new Error(first?.Mensagem || 'Falha ao salvar cliente');
  }

  const pessoaClienteId = Number(first.ID || 0);

  const created: Customer = {
    id: String(pessoaClienteId || ''),
    name: input.name,
    document: input.document,
    phone: input.phone,
    email: input.email,
    address: input.address,
    city: input.city,
    state: input.state,
    zipCode: input.zipCode,
    clienteID: pessoaClienteId || undefined,
  };

  return created;
}
